import '.ga{padding:16px 8px;}.ssr-plugin'
import '.d8{position:fixed;}.ssr-plugin'
import '.fc{z-index:1;}.ssr-plugin'
import '.bd{bottom:0px;}.ssr-plugin'
import '.ag{left:0px;}.ssr-plugin'
import '.be{right:0px;}.ssr-plugin'
import '.bv{display:none;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.gb{padding:16px 16px 16px 32px;}.ssr-plugin'
import '.cm{border-radius:40px;}.ssr-plugin'
import '.co{gap:48px;}.ssr-plugin'
import '.gc{max-width:1312px;}.ssr-plugin'
import '.ap{margin:0 auto;}.ssr-plugin'
import '.h{flex:1;}.ssr-plugin'
import '.b1{box-sizing:border-box;}.ssr-plugin'
import '.gd{padding-top:8px;}.ssr-plugin'
import { styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { Button } from './Button.js'
import { Icon } from '../assets/icons/index.js'
import { Meter } from './Meter.js'
import { useLocation } from 'wouter'
import { TABLET } from '../utils/breakpoints.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { MODAL_PANEL_ANIMATION } from './ModalWrapper.js'
import { useDictionary } from '../hooks/useDictionary.js'

export const Banner = ({ total, maxVotes }) => {
  const [, setLocation] = useLocation()
  const dictionary = useDictionary()

  return (
    <styled.div className="ga d8 fc bd ag be bv"
      style={{
        background: `linear-gradient(0deg,${transparentColor(colors.secondary, 1)} 0%, ${transparentColor(colors.secondary, 0)} 100%)`,
        [TABLET]: {
          display: !total ? 'none' : 'block',
        },
      }}
    >
      <styled.div className="blur e w ao gb cm co gc ap"
        style={{
          border: `1px solid ${colors.border}`,
          backgroundColor: transparentColor(colors.secondary, 0.3),
          animation: MODAL_PANEL_ANIMATION,
          [TABLET]: {
            maxWidth: '480px',
          },
        }}
      >
        <div className="h b1 gd"
        >
          <Meter
            value={(total / maxVotes) * 100}
            style={{ marginBottom: 12 }}
          />
          <styled.p>{dictionary.nOutOfMaxVotes}</styled.p>
        </div>
        <Button
          trailIcon={<Icon type="forwardIcon" color={colors.secondary} />}
          onClick={() => setLocation('/cart')}
        >
          {dictionary.cart}
        </Button>
      </styled.div>
    </styled.div>
  )
}
